import { useIsMobile } from "../../hooks/useIsMobile";

const NAV_TABS = [
  { id: "dashboard",    label: "Overview",  icon: "⊞" },
  { id: "accounts",     label: "Accounts",  icon: "◫" },
  { id: "transactions", label: "Txns",      icon: "↕" },
  { id: "budget",       label: "Budget",    icon: "◎" },
  { id: "investments",  label: "Invest",    icon: "↗" },
];

export default function BottomNav({ activeNav, onNavChange }) {
  const isMobile = useIsMobile();
  if (!isMobile) return null;

  return (
    <nav style={{
      position: "fixed", bottom: 0, left: 0, right: 0,
      background: "var(--bg-surface)",
      borderTop: "1px solid var(--border)",
      display: "flex",
      zIndex: 200,
      paddingBottom: "env(safe-area-inset-bottom, 0px)",
    }}>
      {NAV_TABS.map(tab => {
        const isActive = activeNav === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onNavChange(tab.id)}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px 4px 8px",
              background: "none",
              border: "none",
              cursor: "pointer",
              gap: "3px",
              transition: "opacity 0.15s",
              opacity: isActive ? 1 : 0.5,
            }}
          >
            <span style={{
              fontSize: "18px",
              color: isActive ? "#D4AF37" : "var(--text-secondary)",
              lineHeight: 1,
            }}>
              {tab.icon}
            </span>
            <span style={{
              fontSize: "9px",
              fontFamily: "'JetBrains Mono', monospace",
              letterSpacing: "0.06em",
              color: isActive ? "#D4AF37" : "var(--text-muted)",
              fontWeight: isActive ? "600" : "400",
              textTransform: "uppercase",
            }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
